(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-featured-collection"] && !Shopify.designMode) return;
  try {
    
// Progressive enhancement: without JavaScript the original products and link remain available.
const osakiCollectionInstances = new WeakMap();
const osakiCollectionConfigSelector =
  'script[data-section-type="dynamic-featured-collection"][data-osaki-expand="true"]';

function osakiInitCollection(root, config) {
  if (osakiCollectionInstances.has(root)) return;

  const container = root.querySelector('[data-featured-collection]');
  const grid = container && container.querySelector('.featured-collection__content[data-content]');
  if (!grid) return;

  const products = Array.from(grid.querySelectorAll('[data-product-item]')).filter(
    product => product.closest('[data-content]') === grid
  );
  if (!products.length) return;

  const originalLink = container.querySelector('a.featured-collection__button');
  const originalGridId = grid.getAttribute('id');
  const originalHidden = products.map(product => product.hidden);
  const button = document.createElement('button');
  const status = document.createElement('span');
  const mobile = window.matchMedia('(max-width: 859px)');
  const initialCount = 5;
  let expanded = false;
  let frame = 0;

  const expandLabel = config.dataset.osakiExpandLabel || 'View all products';
  const collapseLabel = config.dataset.osakiCollapseLabel || 'Show less';
  const buttonStyle = config.dataset.osakiButtonStyle === 'secondary' ? 'secondary' : 'primary';

  function isGridLayout() {
    return mobile.matches ? grid.dataset.mobileLayout === 'grid' : grid.dataset.layout === 'grid';
  }

  function render() {
    const gridLayout = isGridLayout();
    const hasMore = products.length > initialCount;
    products.forEach((product, index) => {
      const conceal = gridLayout && !expanded && index >= initialCount;
      product.toggleAttribute('data-osaki-expand-hidden', conceal);
      product.hidden = originalHidden[index] || conceal;
    });
    root.toggleAttribute('data-osaki-expand-grid', gridLayout);
    button.hidden = !gridLayout || !hasMore;
    button.textContent = expanded ? collapseLabel : expandLabel;
    button.setAttribute('aria-expanded', String(expanded && gridLayout));
  }

  function scheduleLayoutRefresh() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      // Existing theme image/slider handlers can remeasure newly visible cards.
      window.dispatchEvent(new Event('resize'));
    });
  }

  function onClick() {
    expanded = !expanded;
    render();
    status.textContent = `Showing ${expanded ? products.length : initialCount} products.`;

    // Keep keyboard focus in view when a long product list changes height.
    if (expanded) {
      const nextProduct = products[initialCount];
      const nextLink = nextProduct && nextProduct.querySelector('a[href]:not([tabindex="-1"])');
      if (nextLink) nextLink.focus({ preventScroll: true });
      if (nextProduct) nextProduct.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    } else {
      button.focus({ preventScroll: true });
      button.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }
    scheduleLayoutRefresh();
  }

  function onLayoutChange() {
    // A slideshow must keep all its cards available for the theme's carousel.
    render();
    status.textContent = '';
    scheduleLayoutRefresh();
  }

  function cleanup() {
    cancelAnimationFrame(frame);
    button.removeEventListener('click', onClick);
    mobile.removeEventListener('change', onLayoutChange);
    products.forEach((product, index) => {
      product.removeAttribute('data-osaki-expand-hidden');
      product.hidden = originalHidden[index];
    });
    root.removeAttribute('data-osaki-expand-grid');
    if (originalLink && button.parentNode) button.replaceWith(originalLink);
    else button.remove();
    status.remove();
    if (originalGridId === null) grid.removeAttribute('id');
    osakiCollectionInstances.delete(root);
  }

  try {
    if (!grid.id) grid.id = `OsakiCollectionProducts-${config.dataset.sectionId}`;
    button.type = 'button';
    button.className = originalLink
      ? originalLink.className
      : `button-${buttonStyle} featured-collection__button`;
    button.setAttribute('data-osaki-expand-button', '');
    button.setAttribute('aria-controls', grid.id);
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', onClick);

    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');

    if (originalLink) originalLink.replaceWith(button);
    else container.appendChild(button);
    button.after(status);
    mobile.addEventListener('change', onLayoutChange);
    render();
    osakiCollectionInstances.set(root, { cleanup });
  } catch (error) {
    cleanup();
    console.warn('[Featured collection] Expand controls could not initialize.', error);
  }
}

function osakiScanCollections(scope) {
  scope.querySelectorAll(osakiCollectionConfigSelector).forEach(config => {
    const root = config.closest('.shopify-section');
    if (root) osakiInitCollection(root, config);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => osakiScanCollections(document), { once: true });
} else {
  osakiScanCollections(document);
}

document.addEventListener('shopify:section:load', event => osakiScanCollections(event.target));
document.addEventListener('shopify:section:unload', event => {
  const instance = osakiCollectionInstances.get(event.target);
  if (instance) instance.cleanup();
});

  } catch(e) { console.error(e); }
})();
})();
